import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, withRouter } from 'react-router-dom';
import {
  CenterMediumContent,
  ContainedButton,
  DefaultText,
  Form,
  FormActions,
  FullScreenSpinner,
  MediumText,
  PasswordBox,
  SmallText,
} from '@guryou/html-components';
import { cognitoSetNewPassword, stateIsLoaded, StateStatus } from '@guryou/redux';
import { cognitoPasswordRequirements } from '@guryou/utils';
import { persistor } from 'store';

import './main.css';

const defaultState = {
  password: '',
  confirmPassword: '',
};

const ResetPassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [ls, setLs] = useState(defaultState);
  const setNewPassword = useSelector(state => state.cognito.setNewPassword);
  const { email, code } = useParams();

  if (setNewPassword.status === StateStatus.LOADING) {
    return <FullScreenSpinner />;
  }

  const handleInputsChange = (value, e, input) => {
    e.persist();
    setLs(prevState => ({ ...prevState, [input]: value }));
  };
  const handleSubmit = async data => {
    const { newPassword } = data;
    dispatch(cognitoSetNewPassword({ newPassword, email, code }, persistor));
  };

  const passwordStrength = cognitoPasswordRequirements(ls.password);
  const checkIfPasswordMatch = ls.password === ls.confirmPassword;

  return (
    <CenterMediumContent isPublicContent={false}>
      <Form className="login" onSubmit={handleSubmit} actions={false}>
        <div className="logoBg"></div>
        {stateIsLoaded(setNewPassword) ? (
          <>
            <MediumText textAlign="center">{t('NOTIFICATIONS.successChangedPass')}</MediumText>
          </>
        ) : (
          <>
            <DefaultText textAlign="center">{t('CONFIRMATIONS.enterYourNewPassword')}</DefaultText>
            <PasswordBox
              onChange={(value, e) => handleInputsChange(value, e, 'password')}
              name="newPassword"
              label={t('GENERAL.password')}
              autoComplete="current-password"
              required
            />
            <PasswordBox
              onChange={(value, e) => handleInputsChange(value, e, 'confirmPassword')}
              name="confirmPassword"
              label={t('PROFILE.confirmPass')}
              autoComplete="current-password"
              required
            />
          </>
        )}
        <FormActions>
          {stateIsLoaded(setNewPassword) ? (
            <ContainedButton
              color="primary"
              text={`${t('GENERAL.backToLogin')}`}
              onClick={e => {
                e.preventDefault();
                history.push('/login');
              }}
            />
          ) : (
            <ContainedButton disabled={!!passwordStrength || !checkIfPasswordMatch} color="primary" type="submit" text={t('GENERAL.save')} />
          )}
        </FormActions>
        <SmallText color="red" padding={2}>
          {setNewPassword.error && setNewPassword.error.message}
        </SmallText>
        <SmallText padding={2} color="red">
          {passwordStrength && passwordStrength}
        </SmallText>
        <SmallText padding={2} color="red">
          {ls.password.length >= 8 && ls.confirmPassword && !checkIfPasswordMatch && t('ACCOUNT.newAndConfirmPassDontMatch')}
        </SmallText>
      </Form>
    </CenterMediumContent>
  );
};

export default withRouter(ResetPassword);
